import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  getConversationOptions,
  getConversationQueryKey,
  setConversationRuntimePolicyMutation,
} from '../../generated/api/@tanstack/react-query.gen.js';
import { RuntimePolicySurface } from '../../generated/api/types.gen.js';
import { RuntimePolicyMenu } from '../ui/RuntimePolicyMenu.js';

interface ConversationPolicyControlProps {
  conversationId: string;
}

/** Composer control: the runtime policy this conversation runs under; picking another applies it at once. */
export function ConversationPolicyControl({ conversationId }: ConversationPolicyControlProps) {
  const queryClient = useQueryClient();
  const path = { id: conversationId };
  const detail = useQuery(getConversationOptions({ path }));
  const mutation = useMutation({
    ...setConversationRuntimePolicyMutation(),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: getConversationQueryKey({ path }) }),
  });

  return (
    <RuntimePolicyMenu
      surface={RuntimePolicySurface.CONVERSATION}
      value={detail.data?.runtimePolicyId ?? null}
      onChange={(runtimePolicyId) => mutation.mutate({ path, body: { runtimePolicyId } })}
      disabled={mutation.isPending}
      error={mutation.isError ? mutation.error.message : null}
      placement="above"
    />
  );
}
